import { NotImplementedError } from "../../../utils/Error";
export class WebSubShader {
    setUniformMap(_uniformMap) {
    }
    destroy() {
        throw new NotImplementedError();
    }
    addShaderPass(pass) { }
}
